import { render } from "./hue.vue?vue&type=template&id=9d34d660&scoped=true"
import script from "./hue.vue?vue&type=script&lang=js"
export * from "./hue.vue?vue&type=script&lang=js"

import "./hue.vue?vue&type=style&index=0&id=9d34d660&scoped=true&lang=css"

import exportComponent from "C:\\Users\\86134\\Desktop\\Web\\Item\\来画设计\\laiiva-web\\packages\\QColor\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d34d660"]])

export default __exports__